import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ReportsComponent } from './reports.component';

const routes: Routes = [{
  path: 'reports',
  component: ReportsComponent,
  data: {
    title: 'Reports'
  }
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class ReportsRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/pages/reports/reports-routing.module.ts